<template>
  <Modal :is-open="isOpen" default-success-msg="Success">
    <template #form="{}">
      <transition
        mode="out-in"
        enter-active-class="transition duration-300 ease-out transform"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <div v-if="!add_new_field_is_shown">
          <h3 class="text-2xl font-medium leading-10 text-gray-900 capitalize dark:text-white">
            <span>{{ $t("Add new") }} </span>
            <transition
              mode="out-in"
              enter-active-class="transition duration-300 ease-out transform "
              enter-from-class="opacity-0 translate-y-30"
              enter-to-class="translate-y-0 opacity-100">
              <span :key="selected_entity_type" class="capitalize">
                {{ selected_entity_type == "company" ? "Company" : selected_entity_type }}
              </span>
            </transition>
          </h3>
          <hr class="mt-2 -mx-6 border-light-divider-border dark:border-dark-divider-border">
          <div v-if="!parentId" class="flex justify-center mx-3 -space-y-px">
            <div v-if="selectedRecord?.type == 'company' && selected_entity_type == 'company'" class="flex w-full gap-2 mt-5">
              <SelectInput
                v-model:current-item="selected_entity_type"
                :value="selected_entity_type"
                name="selected_entity_type"
                :items="[
                  { value: 'company', label: $t('Company') },
                  { value: 'department', label: $t('Department') },
                  { value: 'contact', label: $t('Contact') }
                ]"
                label-attr="label"
                :allow-null="false"
                classes="w-1/2"
                value-attr="value"
                :label="$t('Entity type')"
                :show-label="true"
                :is-box-background="true"
                input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
              <SelectInput
                v-model:current-item="selected_company_type"
                name="selected_company_type"
                :value="selected_company_type"
                :items="selectedRecord?.parent ? ['Parent', 'Sister', 'Child'] : ['Parent', 'Child']"
                :label-attr="null"
                :allow-null="false"
                :show-label="true"
                :classes="'w-1/2'"
                :label="$t('Relationship type')"
                :is-box-background="true"
                input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
            </div>
            <div v-else class="flex justify-center w-full mt-5">
              <div class="w-1/3">
                <SelectInput
                  v-if="selectedRecord.type != 'contact'"
                  v-model:current-item="selected_entity_type"
                  :value="selected_entity_type"
                  name="selected_entity_type"
                  :items="[
                    { value: 'department', label: $t('Department') },
                    { value: 'contact', label: $t('Contact') }
                  ]"
                  label-attr="label"
                  :allow-null="false"
                  :classes="'w-full'"
                  value-attr="value"
                  :label="$t('Entity type')"
                  :show-label="true"
                  :is-box-background="true"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
                <SelectInput
                  v-else
                  v-model:current-item="selected_entity_type"
                  :value="selected_entity_type"
                  name="selected_entity_type"
                  :items="[{ value: 'contact', label: $t('Contact') }]"
                  label-attr="label"
                  :allow-null="false"
                  :classes="'w-full'"
                  value-attr="value"
                  :label="$t('Entity type')"
                  :show-label="true"
                  input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
              </div>
            </div>
          </div>
          <Form
            v-slot="{ isSubmitting }"
            :validation-schema="schema"
            class="space-y-6 overflow-visible min-h-[250px] flex flex-col"
            @submit="
              createRecord(() => {
                $emit('update:isOpen', false)
              })
            ">
            <div class="mb-auto -space-y-px rounded-md">
              <div v-if="record_metrics.length > 0" class="p-3 mt-5 rounded-sm">
                <div class="grid w-full h-full grid-cols-1 gap-2 sm:grid-cols-2">
                  <div v-for="metric in record_metrics" :key="metric.id" class="mb-2">
                    <!-- this is working just for add company in MAP -->
                    <div v-if="selected_entity_type == 'company' && metric.id == $utils.getOptionMetricReference('company', 'name')">
                      <RecordAutoCompleteInput
                        v-model="metric.value"
                        :icon="null"
                        :name="metric.reference_name"
                        :filter-metric-ids="[$utils.getOptionMetricReference('company', 'name')]"
                        :is-async="true"
                        label=""
                        :is-box-background="true"
                        :placeholder="$t('Search for existing companies or create new one')"
                        type="text"
                        classes="p-0 m-0 border-0"
                        @changed="
                          ($event) => {
                            metric.value = $event
                          }
                        "
                        @chosen="
                          ($event) => {
                            to_be_linked_company = $event
                          }
                        " />
                    </div>

                    <MetricFieldInput
                      v-else
                      v-model:metric-value="metric.value"
                      :metric="metric"
                      :show-success-check-mark="true"
                      class="w-full"
                      @validation="validateField" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end px-3">
              <div class="primary-outline-btn w-fit" @click="add_new_field_is_shown = true">
                <Plus class="w-5 h-5" />
                <div class="pl-1">
                  {{ $t("Add Metric") }}
                </div>
              </div>
            </div>

            <div class="flex flex-row justify-between w-full gap-2 pt-2">
              <button type="button" class="w-1/2 m-0 cancel-btn dark:border-dark-divider-border" @click="$emit('update:isOpen', false)">
                {{ $t("Cancel") }}
              </button>

              <button type="submit" :disabled="isSubmitting" class="relative w-1/2 primary-btn disabled:bg-opacity-50">
                {{ add_button_labels[selected_entity_type] }}
              </button>
            </div>
          </Form>
        </div>
        <div v-else>
          <h3 class="text-2xl font-medium leading-10 text-center text-gray-800 dark:text-white">
            {{ $t("New Field") }}
          </h3>
          <NewFieldForm
            v-model:included-metrics="record_metrics"
            :page-reference="pageReference"
            :object-type="objectType"
            :view-type="VIEW_TYPES.FORM_CREATE"
            @cancel="
              () => {
                prepareValidationSchema()
                add_new_field_is_shown = false
              }
            "
            @done="
              () => {
                prepareValidationSchema()
                add_new_field_is_shown = false
              }
            " />
        </div>
      </transition>
    </template>
  </Modal>
</template>
<script>
import * as Yup from "yup"
import Modal from "@/components/shared/Modal.vue"
import dataService from "@/services/data.service"
import RecordAutoCompleteInput from "@/components/shared/RecordAutoCompleteInput.vue"
import { Form } from "vee-validate"
import NewFieldForm from "@/components/forms/NewFieldForm.vue"
import MetricFieldInput from "@/components/shared/MetricFieldInput.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import { Plus } from "lucide-vue-next"
import { VIEW_TYPES } from "@/store/constants/references"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    Plus,
    SelectInput,
    MetricFieldInput,
    NewFieldForm,
    Form,
    RecordAutoCompleteInput,
    Modal
  },
  inject: ["getViewMetrics"],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedRecord: {
      type: Object
    },
    parentId: {
      type: String,
      default: null
    },

    isAddContact: {
      type: Boolean,
      default: false
    },
    objectType: {
      type: String,
      required: false
    },
    pageReference: {
      type: String,
      required: true
    }
  },
  emits: ["updateMap", "refreshTable", "update:isOpen"],
  data() {
    return {
      add_button_labels: {
        company: this.$t("Add company"),
        contact: this.$t("Add contact"),
        department: this.$t("Add department")
      },
      is_valid_value: false,
      add_new_field_is_shown: false,
      selected_entity_type: "company",
      selected_company_type: "Child",
      to_be_linked_company: null,
      record_metrics: [],
      is_submitting: false,
      VIEW_TYPES,
      schema: {}
    }
  },

  watch: {
    selected_entity_type() {
      this.is_valid_value = false
      this.selected_company_type = "Child"
      this.initIncludedMetrics()
    },
    isOpen() {
      if (this.isOpen) {
        this.is_valid_value = false
        this.selected_entity_type = this.selectedRecord.type
        this.initIncludedMetrics()
      }
    },
    to_be_linked_company() {
      if (this.to_be_linked_company && this.selected_entity_type == "contact") {
        this.validateField(true)
      } else if (!this.to_be_linked_company && this.selected_entity_type == "contact") {
        this.validateField(false)
      }
    },
    selected_company_type() {
      if (this.selected_company_type && this.selected_entity_type == "company") {
        this.validateField(true)
      } else if (!this.selected_company_type && this.selected_entity_type == "company") {
        this.validateField(false)
      }
    }
  },

  activated() {
    this.register_listeners()
    if (this.isAddContact) {
      this.selected_entity_type = "contact"
    }
  },
  created() {
    this.register_listeners()
    if (this.isAddContact) {
      this.selected_entity_type = "contact"
    }
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.NEW_FIELD_ADDED, () => {
        this.getRecordMetrics()
      })
      this.$emitter.on(ALL_EMITTERS.ADD_CONTAC_PLG, () => {
        this.selected_entity_type = "contact"
      })
      this.$emitter.on(ALL_EMITTERS.ADD_COMPANY_PLG, () => {
        this.selected_entity_type = "company"
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.NEW_FIELD_ADDED)
      this.$emitter.off(ALL_EMITTERS.ADD_CONTAC_PLG)
      this.$emitter.off(ALL_EMITTERS.ADD_COMPANY_PLG)
    },
    prepareValidationSchema() {
      this.schema = {}

      let required_metrics = [
        this.$utils.getOptionMetricReference("company", "website"),
        this.$utils.getOptionMetricReference("company", "name"),
        this.$utils.getOptionMetricReference("contact", "first_name"),
        this.$utils.getOptionMetricReference("contact", "last_name"),
        this.$utils.getOptionMetricReference("contact", "email"),
        this.$utils.getOptionMetricReference("department", "name"),
        this.$utils.getOptionMetricReference("opportunity", "name"),
        this.$utils.getOptionMetricReference("opportunity", "amount")
      ]

      this.record_metrics?.forEach((metric) => {
        if (required_metrics.includes(metric.reference_name)) {
          if (metric.input_type == "URL") {
            this.schema[metric.reference_name] = Yup.string(`${metric.name} ` + this.$t("is required"))
              .matches(
                /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){0,1}([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/,
                this.$t("Please enter a valid url address")
              )
              .required(`${metric.name} ` + this.$t("is required"))
              .nullable()
          } else if (metric.data_type == "Number") {
            this.schema[metric.reference_name] = Yup.number(this.$t("Please enter a valid number"))
              .required(`${metric.name} ` + this.$t("is required"))
              .nullable()
          } else if (metric.input_type == "Email") {
            this.schema[metric.reference_name] = Yup.string().email(this.$t("Please enter a valid email address")).nullable()
          } else {
            this.schema[metric.reference_name] = Yup.string()
              .required(`${metric.name} ` + this.$t("is required"))
              .nullable()
          }
        } else {
          if (metric.input_type == "URL") {
            this.schema[metric.reference_name] = Yup.string()
              .matches(
                /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){0,1}([0-9A-Za-z-\\.@:%_\\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/,
                this.$t("Please enter a valid url address")
              )
              .nullable()
          } else if (metric.data_type == "Number") {
            this.schema[metric.reference_name] = Yup.string()
              .matches(/^[0-9-.]+$/, this.$t("Please enter a valid number"))
              .nullable()
          } else if (metric.input_type == "Email") {
            this.schema[metric.reference_name] = Yup.string().email(this.$t("Please enter a valid email address")).nullable()
          } else {
            this.schema[metric.reference_name] = Yup.string().nullable()
          }
        }
      })
    },
    validateField(isValid) {
      this.is_valid_value = isValid
      let firstname, lastname
      this.record_metrics.map((record) => {
        if (record.id == this.$utils.getOptionMetricReference("company", "website") && (record.value == null || record.value == "")) {
          this.is_valid_value = false
        } else if (record.id == this.$utils.getOptionMetricReference("company", "name") && (record.value == null || record.value == "")) {
          this.is_valid_value = false
        } else if (record.id == this.$utils.getOptionMetricReference("contact", "first_name")) {
          firstname = record.value
        } else if (record.id == this.$utils.getOptionMetricReference("contact", "last_name")) {
          lastname = record.value
        } else if (
          record.id == this.$utils.getOptionMetricReference("department", "name") &&
          (record.value == null || record.value == "")
        ) {
          this.is_valid_value = false
        }
      })
      if (!firstname && !lastname && this.selected_entity_type == "contact") {
        this.is_valid_value = false
      }
      if (this.selected_entity_type == "contact" && !this.to_be_linked_company) {
        this.is_valid_value = false
      }
      if (!this.selected_company_type && this.selected_entity_type == "company") {
        this.is_valid_value = false
      }
    },
    initIncludedMetrics() {
      this.getRecordMetrics()
      this.prepareValidationSchema()
    },
    getRecordMetrics() {
      this.record_metrics = []
      this.getViewMetrics({
        page_reference: this.pageReference,
        object_type: this.selected_entity_type || this.objectType,
        view_type: VIEW_TYPES.FORM_CREATE
      }).forEach((metric_ref) => {
        this.record_metrics.push({
          ...this.$utils.getMetricByReferenceName(metric_ref),
          value: null,
          is_checked: true
        })
      })
    },

    createRecord() {
      this.is_submitting = true
      if (!this.parentId) {
        if (this.selected_entity_type == "company" && this.to_be_linked_company) {
          if (this.selected_company_type == "Child") {
            this.$store
              .dispatch("data/updateRecord", {
                record_id: this.to_be_linked_company.id,
                data: { parent: this.selectedRecord.id }
              })
              .then(() => {
                this.$emit("updateMap")
                this.$emit("update:isOpen", false)
              })
          } else if (this.selected_company_type == "Sister") {
            if (this.selectedRecord.parent) {
              this.createCompany(this.selectedRecord.parent).then(() => {
                this.$store
                  .dispatch("data/updateRecord", {
                    record_id: this.to_be_linked_company.id,
                    data: { parent: this.selectedRecord.parent }
                  })
                  .then(() => {
                    this.$emit("updateMap")
                    this.$emit("update:isOpen", false)
                  })
              })
            }
          } else {
            this.$store
              .dispatch("data/updateRecord", {
                record_id: this.to_be_linked_company.id,
                data: { parent: this.selectedRecord.parent }
              })
              .then(() => {
                this.$emit("updateMap")
                this.$emit("update:isOpen", false)
              })
          }
        } else {
          if (this.selected_entity_type == "company") {
            if (this.selected_company_type == "Child") {
              this.createCompany(this.selectedRecord.id).then(() => {
                this.$emit("updateMap")
                this.$emit("update:isOpen", false)
              })
            } else if (this.selected_company_type == "Sister") {
              if (this.selectedRecord.parent) {
                this.createCompany(this.selectedRecord.parent).then(() => {
                  this.$emit("updateMap")
                  this.$emit("update:isOpen", false)
                })
              }
            } else {
              this.createCompany(this.selectedRecord.parent).then((res) => {
                this.$store
                  .dispatch("data/updateRecord", {
                    record_id: this.selectedRecord.id,
                    data: { parent: res.data.id }
                  })
                  .then(() => {
                    this.$emit("updateMap")
                    this.$emit("update:isOpen", false)
                  })
              })
            }
          } else {
            this.createCompany(this.selectedRecord.id).then(() => {
              this.$emit("updateMap")
              this.$emit("refreshTable")
              this.$emit("update:isOpen", false)
            })
          }
        }
      } else {
        this.createCompany(this.parentId).then(() => {
          this.$emit("updateMap")
          this.$emit("refreshTable")
          this.$emit("update:isOpen", false)
        })
      }
    },
    createCompany(parent) {
      return new Promise((res) => {
        let metrics_values = {}
        this.record_metrics?.forEach((metric) => {
          metrics_values[metric.reference_name] = metric.value
        })
        return res(
          dataService.createRecord({
            values: metrics_values,
            object_id: "RANDOM",
            object_type: this.$utils.getObjectTypeByType(this.selected_entity_type).id,
            parent: parent,
            origin: "platform-maps"
          })
        )
      })
    }
  }
}
</script>

<style scoped>
.org-tree-container {
  background-color: transparent !important;
}
.org-tree-node-label-inner {
  padding: 0px !important;
}
#HiddenNode {
  display: none;
}
.ghostItem {
  @apply bg-gray-900 border-0;
}
.chosenItem {
  @apply bg-transparent border-0;
}
.ghost {
  @apply bg-gray-900 border-0;
}
.chosen {
  @apply bg-gray-700 border-0;
}
</style>
